import { inject } from 'mobx-react';
import * as React from 'react';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiSpaceDetailsWrapper } from 'components/infosite/shared-ui/offers/space-details-wrapper';

interface SpaceDetailsWrapperProps {
  currentHotel?: CurrentHotelStore;
}

export const SpaceDetailsWrapper: React.FunctionComponent<SpaceDetailsWrapperProps> = inject('currentHotel')(() => (
  <UitkSpacing margin={{ block: 'six' }}>
    <div>
      <SharedUiSpaceDetailsWrapper />
    </div>
  </UitkSpacing>
));
